import React from 'react';
import { PlayIcon } from 'lucide-react';
import { MOCK_VIDEOS } from '../../data/mockData';
export function VideoGrid() {
  // Multiply mock videos to fill the grid
  const gridVideos = [...MOCK_VIDEOS, ...MOCK_VIDEOS, ...MOCK_VIDEOS];
  return <div className="grid grid-cols-3 gap-0.5" data-id="element-131">
      {gridVideos.map((video, i) => <div key={`${video.id}-${i}`} className="relative aspect-[3/4] bg-surface cursor-pointer group" data-id="element-132">
          <div className={`absolute inset-0 bg-gradient-to-br ${video.color} opacity-80 group-hover:opacity-100 transition-opacity`} data-id="element-133" />

          {/* View Count Overlay */}
          <div className="absolute bottom-1 left-1 flex items-center gap-1 text-white" data-id="element-134">
            <PlayIcon size={12} className="fill-white" data-id="element-135" />
            <span className="text-[10px] font-bold drop-shadow-md" data-id="element-136">
              {(Math.random() * 100 + 10).toFixed(1)}K
            </span>
          </div>
        </div>)}
    </div>;
}